module.exports = __webpack_public_path__ + "static/img/R401A.f972eab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R401A.jpg
// module id = f/X+
// module chunks = 1